import React from 'react'
import "./Mechanical.css"
import Slider from '../../Home/Slider/Slider'
import Mechanical1 from "../Departmentimage/IMG_1525 (FILEminimizer).JPG"
import Mechanical2 from "../Departmentimage/IMG_1516 (FILEminimizer).JPG"
const Mechanical = () => {
  return (
    <div className='main-container-mechanical'>
      {/* <Slider></Slider> */}
      <div data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1500">
      <div className='container-mechanical'> 
        <h1>MECHANICAL ENGINEERING</h1>
        </div>
      
        <div className='container-mechanical2'>
        
       
<div data-aos="fade-up"
     data-aos-anchor-placement="top-bottom">

        <div className='container-mechanical1'>
        <div data-aos="fade-right"
     data-aos-offset="300"
     data-aos-easing="ease-in-sine">
          <p>
          The department of mechanical engineering offers a three years 
          diploma and four-years program leading to the Bachelors Degree in              
          Mechanical Engineering. The vision of the department is to create 
          high quality mechanical engineers who can face the real world 
          problems and adapt quickly to the rapid technological changes 
          without sacrificing their ethical and moral values. <br /> <br />
          The mission of the department is to impart the best teaching, 
          learning environment and to ensure sufficient technological 
          exposure to the students by providing them high quality modern 
          mechanical engineering laboratories. The department ensures 
          their lifelong learning by effective counselling & helps them to 
          achieve their career goals under guidance of highly qualified faculty 
          . <br /> <br />
            The department of mechanical engineering strives to produce the 
            best mechanical engineers who can perform globally. To sharpen 
            core mechanical engineering skills of the students by judicious 
            blend of theoretical and practical measures, the department is 
            equipped with all the modern mechanical engineering laboratories, 
             as CAD- CAM lab (having design software i.e. Auto CAD, Solid 
            , CATIA,. ANSYS, CREO & ProE), Thermodynamics lab, I C 
            Engines and Gas Turbines lab, Fluid Mechanics lab, Fluid Machinery 
            , Automobile Engineering lab, Refrigeration and Air Conditioning 
            lab, Engineering Mechanics lab, Material Science lab, Strengths of 
            Material lab, Production Technology and Mechanical Workshop. The 
             focuses on creative and innovative classroom teaching, 
             work, interpersonal communication skills, and research 
            activities. The department uses modern methodologies like 
            interactive lectures, guided case studies, literature surveys and 
            project work. <br /> <br />  
          </p> <hr />
          </div>      
        <div className='mechanical-image'> 
        <div data-aos="flip-left"
     data-aos-easing="ease-out-cubic"
     data-aos-duration="2000">

          <img src={Mechanical1} className='Mechanical1' />
          <img src={Mechanical2} className='Mechanical1' />
          </div>
        </div>
      </div>
      </div>
      </div>
      </div>  
    </div>
  )
}

export default Mechanical
